<template>
  <div id="footer" :class="footerClass">
    <p class="description">©︎ 2020 Matsuo</p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    footerClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
#footer {
  position: fixed;
  bottom: 0px;
  height: 33px;
  width: 100%;
}
.description {
  margin-left: 5px;
  position: absolute;
  bottom: 0;
  font-size: 50%;
}
</style>